import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayOfYear from 'dayjs/plugin/dayOfYear';
import localeData from 'dayjs/plugin/localeData';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import shortTimezoneAbbreviation from './plugins/shortTimezoneAbbreviation/shortTimezoneAbbreviation';

// Configure dayjs with all required plugins
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(dayOfYear);
dayjs.extend(localizedFormat);
dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);
dayjs.extend(relativeTime);
dayjs.extend(localeData);
dayjs.extend(shortTimezoneAbbreviation);

const localeMapping = Object.freeze({
  'zh-Hans': 'zh-cn',
  'zh-Hant': 'zh-tw',
});

// the locale of the page is stored in window.I18n.locale
// all the necessary dayjs locales are loaded in assets/entries/locales/*.js
// so we can set it here without loading it again
if (window.I18n?.locale) {
  dayjs.locale(localeMapping[window.I18n.locale] || window.I18n.locale);
}

// Export the configured instance
export default dayjs;
